import { render } from "./EventCreationMethod.vue?vue&type=template&id=3f602ed2&scoped=true"
import script from "./EventCreationMethod.vue?vue&type=script&lang=js"
export * from "./EventCreationMethod.vue?vue&type=script&lang=js"

import "./EventCreationMethod.vue?vue&type=style&index=0&id=3f602ed2&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f602ed2"]])

export default __exports__